import { Collapsible, CollapsibleContent } from "@workspace/frontend-ui";
import type { CSSProperties, FC } from "react";
import useRewardCenter from "../../actors/useRewardCenter";
import Arcs from "../../assets/Arcs";
import { LOCKED_TIER } from "../../palette";
import getTierLevel from "./getTierLevel";
import TierBars from "./TierBars";
import TierCardHeader from "./TierCardHeader";
import TierFooter from "./TierFooter";
import TierLevels from "./TierLevels";

type Props = {
  id?: string;
};

const TierCard: FC<Props> = ({ id }) => {
  const {
    state: { currentPoints, currentTier, tiers, head },
    send,
  } = useRewardCenter();

  const tier = tiers.find((item) => item.id === (id ?? currentTier));
  if (!tier) return null;

  const { locked, milestones } = getTierLevel(tier, currentPoints);
  const expandable = milestones.length > 0;
  const metal = locked || !tier.hasCms ? LOCKED_TIER : tier;
  const style = {
    "--a1": metal.sheen,
    "--a2": metal.body,
    "--a3": metal.base,
    "--bar": metal.bar,
  } as CSSProperties;

  return (
    <Collapsible
      open={expandable && head.isExpanded}
      onOpenChange={() => send("rewardCenter", { type: "toggleHead" })}
      data-slot="tier-card"
      data-locked={locked}
      className="rc-tier flex flex-col gap-3 overflow-hidden rounded-3xl border-t border-t-foreground/35 p-4 shadow-md"
      style={style}
    >
      <div className="rc-tier-bg">
        <Arcs variant="tier" />
      </div>
      <TierCardHeader tier={tier} expandable={expandable} locked={locked} />
      <div className="h-px bg-foreground/10" />
      <TierBars tier={tier} locked={locked} />
      <TierFooter tier={tier} locked={locked} />
      {expandable && (
        <CollapsibleContent className="rc-collapse">
          <TierLevels tier={tier} />
        </CollapsibleContent>
      )}
    </Collapsible>
  );
};

export default TierCard;
